import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2rpt5ct3p: FaireProductEntity = {
  token: "p_u2rpt5ct3p",
  type: "product",
  name: 'Fish Taper Holder-5"H',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/362cbe59f3a64d64084d6df8561bbca0c7c1f5196b45dea7847332ddf14aa0a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ec716c4e0e42d64bd10776715a35c5e6e67d8ea98c8aa84f5e12cbf36509e3d.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Add a splash of seaside charm to your decor with this Fish Taper Holder. Crafted with intricate details, it perfectly fits a taper candle, creating a warm and inviting glow. Perfect for beach-themed settings or as a unique accent piece, this holder combines functionality with whimsical design.",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:14.125Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
